<template>
    <div class="wrapper wrapper-content wrapper-boxed">

        <div class="row m-t-xl m-b-md">
            <div class="col-sm-12">
                <h1 class="title">{{ review.project ? review.project.title : "" }} - {{ review.name }}</h1>
            </div>
        </div><!-- /.row -->

        <div v-if="$user.isAdmin">
            <div class="ibox ibox-add-user">
                <div class="ibox-title">
                    <h5>New Sprint Review</h5>
                </div>
                <div class="ibox-content">
                    <div class="form-horizontal">
                        <div class="row">
                            <div class="col-md-6 col-lg-4">
                                <div class="form-group">
                                    <label class="control-label col-md-4">Name:</label>
                                    <div class="col-md-8">
                                        <input type="text" placeholder="Sprint 1" class="form-control" v-model="review.name" />
                                    </div>
                                </div><!-- /.form-group -->
                            </div>
                            <div class="col-md-6 col-lg-4">
                                <div class="form-group">
                                    <label class="control-label col-md-4">Project:</label>
                                    <div class="col-md-8">
                                        <selectize
                                            v-if="projects.length"
                                            :options="projects"
                                            name="review_project"
                                            class="selectize bordered"
                                            placeholder="Select project"
                                            :searchable="false"
                                            v-model="review.project_id"
                                            data-vv-as="">
                                          </selectize>
                                    </div>
                                </div><!-- /.form-group -->
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 col-lg-4">
                                <div class="form-group">
                                    <label class="control-label col-md-4">Review Date:</label>
                                    <div class="col-md-8">
                                        <datepicker v-bind:value="review.reviewed_on" @input="selectedDate" input-class="form-control"></datepicker>
                                    </div>
                                </div><!-- /.form-group -->
                            </div>
                        </div><!-- /.row -->

                        <div class="hr-line-dashed"></div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="control-label col-md-2">Sprint Goal:</label>
                                    <div class="col-md-8">
                                        <input type="text" class="form-control" v-model="review.sprint_goal" />
                                    </div>
                                </div><!-- /.form-group -->
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="control-label col-md-2">Achievements:</label>
                                    <div class="col-md-8">
                                        <textarea class="form-control" rows="5" v-model="review.achievements"></textarea>
                                    </div>
                                </div><!-- /.form-group -->
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="control-label col-md-2">What didn't you achieve and why not?:</label>
                                    <div class="col-md-8">
                                        <textarea class="form-control" rows="5" v-model="review.failures"></textarea>
                                    </div>
                                </div><!-- /.form-group -->
                            </div>
                        </div><!-- /.row -->

                        <div class="hr-line-dashed"></div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label col-md-4">Was the deadline affected?:</label>
                                    <div class="col-md-8">
                                        <input type="checkbox" class="form-control" v-model="review.deadline_affected" />
                                    </div>
                                </div><!-- /.form-group -->
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label col-md-4">Was the budget affected?:</label>
                                    <div class="col-md-8">
                                        <input type="checkbox" class="form-control" v-model="review.budget_affected" />
                                    </div>
                                </div><!-- /.form-group -->
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label col-md-4">Estimate vs Actual:</label>
                                    <div class="col-md-8">
                                        <input type="number" class="form-control" v-model="review.estimate_vs_actual">
                                    </div>
                                </div><!-- /.form-group -->
                            </div>
                        </div><!-- /.row -->
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label col-md-4">How many user stories/issues did you complete that weren't part of your goal?:</label>
                                    <div class="col-md-8">
                                        <input type="number" class="form-control" v-model="review.unexpected_tasks"/>
                                    </div>
                                </div><!-- /.form-group -->
                            </div>
                        </div>

                        <div class="hr-line-dashed"></div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="control-label col-md-2">What user stories/issues did you complete that weren't part of your goal?:</label>
                                    <div class="col-md-8">
                                        <textarea class="form-control" rows="5" v-model="review.unexpected_task_comments"></textarea>
                                    </div>
                                </div><!-- /.form-group -->
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="control-label col-md-2">What could you do better next sprint to improve?:</label>
                                    <div class="col-md-8">
                                        <textarea class="form-control" rows="5" v-model="review.improvement_comments"></textarea>
                                    </div>
                                </div><!-- /.form-group -->
                            </div>
                        </div>

                        <div class="hr-line-dashed"></div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label col-md-4">Team performance rating (out of 10):</label>
                                    <div class="col-md-8">
                                        <star-rating :max-rating="10" :star-size="30" v-model="review.team_rating"></star-rating>
                                    </div>
                                </div><!-- /.form-group -->
                            </div>
                        </div><!-- /.row -->
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label col-md-4">Team lead skill rating (out of 10):</label>
                                    <div class="col-md-8">
                                        <star-rating :max-rating="10" :star-size="30" v-model="review.lead_rating"></star-rating>
                                    </div>
                                </div><!-- /.form-group -->
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="control-label col-md-2">Comments on the rates given:</label>
                                    <div class="col-md-8">
                                        <textarea class="form-control" rows="5" v-model="review.rating_comments"></textarea>
                                    </div>
                                </div><!-- /.form-group -->
                            </div>
                        </div>

                        <div class="hr-line-dashed"></div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="control-label col-md-2">General comments:</label>
                                    <div class="col-md-8">
                                        <textarea class="form-control" rows="10" v-model="review.comments"></textarea>
                                    </div>
                                </div><!-- /.form-group -->
                            </div>
                        </div>

                        <div class="hr-line-dashed"></div>

                        <div class="row">
                            <div class="col-md-12 col-lg-12">
                                <ladda-button :on-click="updateReview" class="btn btn-success float-right"><i class="fa fa-plus"></i> Save</ladda-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

    import Review from './../../models/sprint-review.js'
    import StarRating from 'vue-star-rating'
    import Datepicker from 'vuejs-datepicker'
    import { Selectize, LaddaButton } from 'components/form/input'
    
    export default {
        data: function () {
            return {
                review: new Review(),
                projects: [],
            }
        },
        components: {
            StarRating,
            Datepicker,
            Selectize,
            LaddaButton
        },
        created: function() {
            this.fetchData();
        },
        methods: {
            selectedDate (e) {
                this.review.reviewed_on = e
            },

            fetchData: function() {
                var that = this;
                var clientFilter = '';

                Promise.all([
                    client({path: '/sprint-reviews/' + this.$route.params.sprint_review_id }).then(
                        function(response) {
                            that.loading = false;

                            return response.entity
                        },
                        function(response) {
                            
                        }
                    ),
                    client({path: '/projects/list'}).then(
                        function(response) {
                            that.loading = false;

                            return response.entity
                        },
                        function(response) {
                            
                        }
                    ),
                ]).then(function(data) {
                    
                    that.review = data[0]
                    that.projects = data[1]
                })
            },

            updateReview () {
                var that = this
                this.review.reviewed_on = moment(this.review.reviewed_on).format('YYYY-MM-DD')

                return client({path: '/sprint-reviews/' + this.$route.params.sprint_review_id, entity: this.review, method: 'PUT'}).then( 
                    function(response) {
                        
                    },
                    function(response) {
                        if (response.status.code == 422) {
                            var firstValidationIssue = response.entity[Object.keys(response.entity)[0]];
                            
                        } else {
                            
                        }
                    }
                )
            }
        }
    }
</script>

<style scoped>
    
</style>